






















































































import { Component, Vue } from 'vue-property-decorator';
import Api from '../services/Api';
const MaskedInput = require('vue-text-mask').default;
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, max, min } from 'vee-validate/dist/rules';

extend('required', required);
extend('max', max);
extend('min', min);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MaskedInput
  }
})
export default class Home extends Vue {
  private nomor: string = '';
  private password: string = '';
  private ujian: any = '';
  private kodeList: any[] = [];

  ktpPattern: Array<any> = new Array(16).fill(/\d/);
  spinner: boolean = false;
  private publicPath: string = '';

  private apiService: Api;
  constructor() {
    super();
    this.apiService = new Api();
    this.publicPath = process.env.BASE_URL;
  }

  mounted() {
    this.getKode();
  }

  getKode(): void {
    this.spinner = true;
    this.apiService.getResource('/kodetes').then(r => {
      this.kodeList = r;
      this.spinner = false;
    }).catch(err => {
      this.spinner = false;
      this.$toast.error('GAGAL MENDAPATKAN KODE UJIAN');
    });
  }

  tryLogin(): void {
    this.spinner = true;
    this.apiService.postResource('/login', {
      username: this.nomor,
      password: this.password,
      mapel: this.ujian.kode,
      versi: '', deviceId: ''
    }, true).then(r => {
      this.spinner = false;
      if (r.err) {
        let message = '';
        switch (r.err) {
          case 'DONE':
            message = 'Anda sudah mengerjakan ujian ini'; break;
          case 'EXPIRED':
            message = 'Durasi ujian sudah berakhir'; break;
          case 'INVALID':
            message = 'Akun tidak terdaftar'; break;
          case 'VERSI':
            message = 'Gunakan aplikasi dengan versi terbaru'; break;
          case 'ACTIVE':
            message = 'Akun sedang aktif di perangkat lain'; break;
          case 'RELOGIN':
            message = 'Anda harus login ulang'; break;
          case 'VIOLENCE':
            message = 'Anda login lebih dari satu kali, hubungi petugas untuk mereset'; break;
        }
        this.$toast.error(message);
        localStorage.removeItem('username');
        localStorage.removeItem('mapel');
        localStorage.removeItem('shownilai');
        localStorage.removeItem('dikerjakan');
        localStorage.removeItem('ragu');
      } else {
        localStorage.setItem('username', r.data.user);
        localStorage.setItem('mapel', r.data.mapel);
        localStorage.setItem('shownilai', r.data.shownilai);
        localStorage.setItem('dikerjakan', r.data.dikerjakan);
        this.$router.replace({ name: 'Konfirmasi', params: r.data });
      }
    }).catch(err => {
      this.spinner = false;
      this.$toast.error(err.status + ' - ' + err.statusText);
    });
  }
}
